
import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
// import IconSocalFurs from './SocalDate.jpg'
import IconSocalFurs from './Socalfurs.jpg'
import "./Navbar.css";

import DropdownNew from '../components/DropdownNew';  // relative path from layout to components
import DropdownNew2 from '../components/DropdownNew2';
import DropdownNew3 from '../components/DropdownNew3';


export default function Navbar() {

  const [open, setOpen] = useState(false);
  const [close, setCloseNav] = useState(false);
  const menuRef = useRef();
  const linkRef = useRef();


  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  return (
    <nav className="nav-container">
      <div className="icon-name-container">
        <Link to="/" className="navbar-name">SocalFurs</Link>

        <Link to="/">
          <img src={IconSocalFurs} alt="Socalfurs.com" className="navbar-icon" />
        </Link>
      </div>

      <div className='mobile-nav-container'> { /* MOBILE NAVIGATION */ }
        
        <div className="nav-calendar-collapse-container">
          <DropdownNew></DropdownNew>
        </div>

        <div to="" className="nav-calendar-collapse-container-3">
          <DropdownNew3></DropdownNew3>
        </div>

        {/* <div className = "nav-calendar-collapse-container-3">
                      
                      <Link to ="/login" className = "nav-calendar-collapse-text">Login</Link>
                  </div> */}

        <div className="toggle-container-main">
          <div className="dropdown-container" ref={menuRef}>
            {/* Navnar Collapse */}
            <button className="menu-toggle" onClick={() => { setOpen(!open) }}>
              ☰

            </button>
            <div className={`dropdown-menu ${open ? 'active' : 'inactive'}`} >
              <ul>
                <DropdownItem onClick={() => { setOpen(false) }} to="/" text={"Home"} />
                 <DropdownItem onClick={() => { setOpen(false) }} to="/groups" text={"Our Groups Page"} />
                <DropdownItem onClick={() => { setOpen(false) }} to="/calendar" text={"Socal Calendar"} />
                <DropdownItem onClick={() => { setOpen(false) }} to="/events/map" text={"Furry Event Map"} />
                <DropdownItem onClick={() => { setOpen(false) }} to="/norcalcalendar" text={"Norcal Calendar"} />
                <DropdownItem onClick={() => { setOpen(false) }} to="/about" text={"About Us"} />
                <DropdownItem onClick={() => { setOpen(false) }} to="/contact-us" text={"Contact Us"} />
                <DropdownItem onClick={() => { setOpen(false) }} to="/gallery" text={"Photo Gallery"} />
                <DropdownItem onClick={() => { setOpen(false) }} to="https://ko-fi.com/socalfurs" text={"Donate"} />
                <DropdownItem onClick={() => { setOpen(false) }} to="https://calendar.google.com/calendar/embed?src=1cdf9a4e9629d0b119d4daaa0e8ad0cc4d490b3cf95d458b0bf7247e323fb05e%40group.calendar.google.com&ctz=UTC" text={"Subscribe to our Google Calendar"} />
             
                             
                                         
                {/* <DropdownItem onClick ={()=>{setOpen(false)}} to = "/about" text = {"About"}/>
                                  <DropdownItem onClick ={()=>{setOpen(false)}} to = "/contact" text = {"Contact"}/> */}
              </ul>
            </div>
          </div>
        </div>

      </div>

      {/* </div> */}

      <div className='desktop-nav-container'>
        <DropdownNew></DropdownNew>
        <DropdownNew2></DropdownNew2>
        <DropdownNew3></DropdownNew3>
        <Link className="nav-middle-text" to="https://ko-fi.com/socalfurs">Donate</Link>
      </div>
    </nav>
  );
}

function DropdownItem(props) {
  return (
    <li className="dropdown-link">
      <Link className="dropdown-link" to={props.to} onClick={props.onClick}> {props.text} </Link>
    </li>
  );
}

